// Domaines email des collaborateurs OuiSense. Source de vérité UNIQUE de la règle « utilisateur
// OuiSense », partagée par le middleware API (ouisenseOnlyMiddleware) et le front (isOuisenseUser) :
// les deux doivent répondre la même chose, sinon une page s'affiche pour un utilisateur à qui l'API
// répondra 403.
//
// Ajouter un domaine ici si OuiSense en exploite un second.
const OUISENSE_EMAIL_DOMAINS = new Set(['ouisense.io'])

// Compare le DOMAINE de l'adresse, pas une sous-chaîne : un `mail.includes('@ouisense')` accepterait
// aussi bien `x@ouisense.attaquant.com`.
export const isOuisenseEmail = (mail: string | null | undefined): boolean => {
  const domain = mail?.split('@').at(-1)?.toLowerCase()

  return domain !== undefined && OUISENSE_EMAIL_DOMAINS.has(domain)
}
